import React from 'react';
import { ProtectedRoute } from '@/components';
import Home from './home';

export default {
  index: true,
  element: <ProtectedRoute component={<Home />} />,
};
